import { BomDto } from "src/dtos/bom/BomDto";
import { PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";
import { ProductDowntimeDto } from "src/dtos/productDowntime/ProductDowntimeDto";
import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { StockDto } from "src/dtos/stock/stockDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export type KSK2021_R01WorkTimeProcessType = 'workStart' | 'workEnd' | 'workStartReset' | 'workEndReset';

export interface KSK2021_R01Dto {
	productWorkHeaderDto: KSK2021_R01HeaderDto;
	productResultHeaderDto: KSK2021_R01ProductResultDto;
	wmsStockLotDtoList: KSK2021_R01LotDto[];
	bomDtoList: KSK2021_R01DetailDto[];
	prdInspectResultDtoList: PrdInspectResultDto[];
}

export interface KSK2021_R01HeaderDto extends ProductWorkDto {

	//품목 단가를 처리하기 위한 필드
	itemSpec: string;
	itemUnit: string;
	itemCost: number;

	productResultNo: string;
	productDt: string | undefined;

	warehouseCd: string;
	warehouseNm: string;
	outWarehouseCd: string; //출고창고 - detail 검색에 사용
	badWarehouseCd: string; //불량창고 - detail 검색에 사용

	logicCenter: string;
	logicCenterNm: string;
	productQty: number;
	badQty: number;
	acceptQty: number;

	itemStatus: string;

	basOrderType: string;
	basOrderNo: string;
	basOrderItemNo: string;

	itemAccount: string;
	itemAccountNm?: string;

	timeParam: string;
}

export const defaultKSK2021_R01HeaderDto: KSK2021_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	productWorkNo: '',
	productWorkNm: '',
	compCd: '',
	compNm: '',
	workDt: formatDate(new Date()),
	fromTime: undefined,
	toTime: undefined,
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	orderQty: 0,
	workEmp: '',
	workEmpNm: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",
	remark: '',

	itemSpec: '',
	itemUnit: '',
	itemCost: 0,

	productResultNo: '',
	productDt: formatDate(new Date()),

	warehouseCd: '',
	warehouseNm: '',
	outWarehouseCd: '',
	badWarehouseCd: '',

	logicCenter: '',
	logicCenterNm: '',
	productQty: 0,
	badQty: 0,
	acceptQty: 0,

	itemStatus: '',

	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',

	itemAccount: '',
	itemAccountNm: '',

	inserted: false,
	isModified: false,

	timeParam: toLocalDateTime(new Date()),
}

export interface KSK2021_R01ProductResultDto extends ProductResultDto {

	outWarehouseCd: string;
	badWarehouseCd: string;

}

export const defaultKSK2021_R01ProductResultDto: KSK2021_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: 'Y',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	outWarehouseCd: '',
	badWarehouseCd: '',

	inserted: false,
	isModified: false,
}


export interface KSK2021_R01LotDto extends WmsStockLotDto {

}

export const defaultKSK2021_R01LotDto: KSK2021_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}	

export interface KSK2021_R01LotSearchDto extends WmsStockLotDto {

	lotNoInput: string;
	modelNo: string;
	bomUsingQty: number;
	transportQty: number;

}

export const defaultKSK2021_R01LotSearchDto: KSK2021_R01LotSearchDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',	
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	lotNoInput: '',
	modelNo: '',
	bomUsingQty: 0,
	transportQty: 0,

	inserted: false,
	isModified: false,
}	

export interface KSK2021_R01DetailDto extends BomDto {

	warehouseCd: string;
	warehouseNm: string;
	logicCenter: string;
	lotNo: string;
	itemStatus: string;
	itemNm: string;
	itemUnit: string;
	transportNo: string;
	itemNo: string;
	lotQty: number;
	feederNo: string;
	bomUsingQty: number;
	transportQty: number;
	coordinateUsage: number;
}

export const defaultKSK2021_R01DetailDto: KSK2021_R01DetailDto = {

	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: '',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: 'PURCHASE',
	lossPercent: 0,
	remark: '',

	warehouseCd: '',
	warehouseNm: '',
	logicCenter: '',
	lotNo: '',
	itemStatus: '',
	itemNm: '',
	itemUnit: '',
	transportNo: '',
	itemNo: '',
	lotQty: 0,
	feederNo: '',
	bomUsingQty: 0,
	transportQty: 0,
	coordinateUsage: 0,

	inserted: false,
	isModified: false,
}


export interface KSK2021_R01InspectDto extends PrdInspectResultDto {

}

export const defaultKSK2021_R01InspectDto: KSK2021_R01InspectDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	inspectDt: formatDate(new Date()),
	compCd: '',
	inspectType: '',
	inspectorEmp: '',
	supplierCustom: '',
	workplaceCd: '',
	jobTeam: '',
	itemCd: '',
	workerEmp: '',
	inspectQty: 0,
	badQty: 0,
	acceptQty: 0,
	badCase: '',
	basOrderNo: '',
	basOrderItemno: '',
	basLotNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}
